export default __webpack_public_path__ + "db8c0bb5f46f7a840ad4a3361c89df2c.woff";